






























import { Component, Vue } from 'vue-property-decorator';
import Navbar from './layout/navbar/components/Navbar.vue';
import Footer from './layout/footer/Footer.vue';
import AddFunds from './modules/add-funds/AddFunds.vue';
import { State, Action, Getter } from 'vuex-class'
import {ME, IS_LOGGED_IN, FETCH_ACCOUNT, USERNAME} from "./modules/auth/store/constants";
import AddFundsSuccess from '@/modules/add-funds/AddFundsSuccess.vue';

const PAYMENT_SUCCESS_STRING = 'payment_success';

@Component({
  components: {
    Navbar,
    Footer,
    AddFunds,
    AddFundsSuccess
  },
})
export default class App extends Vue {
  private dontNeedFooterPagges = ["CreateTeam"];
  private showAddFundsSuccess = false;

  @Getter(IS_LOGGED_IN) logged!: boolean;
  @Getter(USERNAME) username!: boolean;
  @Action(ME) getUserInfo!: Function;
  @Action(FETCH_ACCOUNT) fetchAccount!: Function;

  get showNavbar() {
    return this.$route.meta.requiresNavbar;
  }

  get showFooter(): boolean {
    // @ts-ignore
    return this.dontNeedFooterPagges.includes(this.$route.name);
  }

  mounted() {
    if (this.showPaymentSuccessNotification) {
      (this as any).$notify({
        group: 'messages',
        title: 'Ha ido bien',
        text: 'El pago se ha realizado correctamente',
        type: 'success'
      });

      setTimeout(() => {
        // this.deleteQueryFromUrl(PAYMENT_SUCCESS_STRING)
      }, 1500);

    }

    if (this.$route.query['add-funds-success']) {
      this.showAddFundsSuccess = true;
    }

    if (this.logged) {
      this.getUserInfo();
    }

    // setInterval(() => {
    //   if (this.logged) {
    //     this.fetchAccount(this.username);
    //   }
    // }, 5000)

  }

  get showPaymentSuccessNotification() {
    return this.$route.query[PAYMENT_SUCCESS_STRING]
  }

  private deleteQueryFromUrl(text: string) {
    let query = Object.assign({}, this.$route.query);
    delete query[text];
    this.$router.replace({ query });
  }

}
